import React from 'react';
import { siteContent } from '../data/mock';
import { Button } from './ui/button';
import { Check } from 'lucide-react';

export const Pricing = () => {
  const { pricing, contact } = siteContent;

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-white border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-stone-900">
            {pricing.title}
          </h2>
          <p className="mt-1 text-stone-500 text-sm">
            {pricing.subtitle}
          </p>
        </div>
        
        <div className="max-w-md mx-auto">
          <div className="bg-stone-50 border-2 border-[#2C3E50] rounded-lg p-6">
            {/* Pricing - prominent */}
            <div className="flex items-center justify-center gap-8 mb-6">
              <div className="text-center">
                <span className="text-4xl font-bold text-[#C67F50]">{pricing.setup.amount}</span>
                <p className="text-sm text-stone-500">{pricing.setup.label}</p>
              </div>
              <div className="w-px h-14 bg-stone-300"></div>
              <div className="text-center">
                <span className="text-4xl font-bold text-stone-900">{pricing.monthly.amount}</span>
                <span className="text-stone-600">{pricing.monthly.label}</span>
              </div>
            </div>
            
            {/* Key reassurances - at a glance */}
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm text-stone-600 mb-6 pb-6 border-b border-stone-200">
              <span className="flex items-center gap-1"><Check className="w-4 h-4 text-[#C67F50]" /> You own everything</span>
              <span className="flex items-center gap-1"><Check className="w-4 h-4 text-[#C67F50]" /> Cancel anytime</span>
            </div>
            
            {/* What you get */}
            <div className="mb-6">
              <p className="font-medium text-stone-800 text-sm mb-3">What you get</p>
              <ul className="space-y-2">
                {pricing.whatYouGet.map((item, index) => (
                  <li key={index} className="flex items-start gap-2">
                    <Check className="w-4 h-4 text-[#C67F50] mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-stone-600">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* To qualify */}
            <div className="border-t border-stone-200 pt-4">
              <p className="font-medium text-stone-800 text-sm">{pricing.toQualify.title}</p>
              <p className="text-xs text-stone-500 mb-1">{pricing.toQualify.intro}</p>
              <ul className="space-y-1">
                {pricing.toQualify.requirements.map((req, index) => (
                  <li key={index} className="text-xs text-stone-600">• {req}</li>
                ))}
              </ul>
            </div>
          </div>
          
          {/* Payment note - visible */}
          <p className="mt-4 text-sm text-stone-500 text-center">
            {pricing.paymentNote}
          </p>
          
          <div className="mt-6 text-center">
            <Button
              onClick={scrollToContact}
              className="bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-3 text-base font-medium h-auto"
            >
              {pricing.cta}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
